<template>
    <transition name="fade-slide">
        <div v-if="showSafariPushPrompt"
            class="safari-prompt"
        >
            <p class="title">開啟推播通知，掌握第一手資訊！</p>
            <p>✅ 立即收到新訂單提醒<br>✅ 重要變更不漏接<br>✅ 無需持續查看，也能隨時掌握進度<br>✅ 推薦在 Safari 或手機瀏覽器中開啟</p>
            <button class="btn btn-primary" @click="triggerPushSetup">立即啟用通知</button>
        </div>
    </transition>
    
</template>
<script>
export default {
    name:'safariPushPrompt',
    data(){
        return {
            showSafariPushPrompt: false
        }
    },
    methods:{
        triggerPushSetup(){
            this.$emit('triggerPushSetupHandle')
        }
    }
}
</script>
<style scoped>
/* Safari 推播提示樣式 */
.safari-prompt {
  position: fixed;
  top: 50%;
  left: 50%;
  background: #ffffff;
  padding: 1rem 3rem;
  border-radius: 0.5rem;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;

  /* 注意：這裡設為 transform(-50%, -50%) 是最終在畫面中央 */
  transform: translate(-50%, -50%);
  opacity: 1; /* 初始不顯示，由動畫控制 */
}

/* 文字樣式 */
.safari-prompt > .title {
  font-size: 1.2rem;
  font-weight: 500;
}

/* 進場動畫：從上往下滑到中間 */
.fade-slide-enter-from {
  /* opacity: 0; */
  transform: translate(-50%, -100%);
}
.fade-slide-enter-to {
  /* opacity: 1; */
  transform: translate(-50%, -50%);
}

/* 離場動畫：從中間滑回上方消失 */
.fade-slide-leave-from {
  /* opacity: 1; */
  transform: translate(-50%, -50%);
}
.fade-slide-leave-to {
  /* opacity: 0; */
  transform: translate(-50%, -100%);
}

/* 過渡效果 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s ease;
}

</style>